module.exports = " <div class=container _v-a63307a6=\"\"> <h1 _v-a63307a6=\"\">{{shopInfo.name}}</h1> <div _v-a63307a6=\"\"> <ul _v-a63307a6=\"\"> <li _v-a63307a6=\"\"> 类型：{{shopInfo.generalName}} </li> <li _v-a63307a6=\"\"> 版本：{{shopInfo.versionName}} </li> </ul> <div class=content _v-a63307a6=\"\"> <img class=logo :src=shopInfo.images _v-a63307a6=\"\"> <div v-html=shopInfo.content _v-a63307a6=\"\"></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-a63307a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wuyan/norisukeInfo.vue
// module id = 221
// module chunks = 1